export default {"src":"/_next/static/media/tr.4feb0516.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};